export const WALLET_CONNECT = "WALLET_CONNECT"
export const WALLET_CHANGE = "WALLET_CHANGE"
export const WALLET_RESET = "WALLET_RESET"
export const WALLET_BALANCE = "WALLET_BALANCE"

export const SESSION_SET_STATUS = "SESSION_SET_STATUS"
export const SESSION_DISCONNECTED = "SESSION_DISCONNECTED"

export const CONTRACT_GET_STAKING_INFO = "CONTRACTS_GET_STAKING_INFO"
